import * as React from "react"
import styles from "./workspaceSettings/WorkspaceSettings.module.scss"
import ModalBox from "../../Componnets/ModalBox/ModalBox";
import Input from "../../Componnets/Input/Input";
import {useEffect} from "react";
import appContext from "../../../context/appContext";
import moment from "moment";
import http from "../../../services/api/utilities/http";

const WorkspaceSettings = (props) => {
  const [selectedTabId, setSelectedTabId] = React.useState(1)
  const [showPopup, setShowPopup] = React.useState(false)
  const [users, setUsers] = React.useState([])
  const [usersToShow, setUsersToShow] = React.useState([])
  const [addedUsers, setAddedUsers] = React.useState([])
  const [apiResponse, setApiResponse] = React.useState(null)
  const [cursor, setCursor] = React.useState(0)

  const context = React.useContext(appContext)

  const popupRef = React.useRef()


  const handleGetAdminAndOwnerUsers = () => {
    const id = (context.handleWorkspace().findIndex(item => item.id === context.handleSelectedWorkspaceInfo().id))
    return [...context.handleWorkspace()[id]?.users.filter(user => !users.find(item => item.username === user)), localStorage.getItem("username")]
  }

  useEffect(() => {
    if (users.length > 0) {
      const usersList = context.handleWorkspace()?.find(workspace => workspace.id === context.handleSelectedWorkspaceInfo().id)?.users
      const selectedUsernames = usersList.filter(user => !handleGetAdminAndOwnerUsers().find(item => item === user))
      const selectedUserObject = users.filter(user => selectedUsernames.find(item => item === user.username))
      setAddedUsers(selectedUserObject)
    }
  }, [users, context.handleSelectedWorkspaceInfo().id])

  const handleClickOutside = e => {
    if (!popupRef.current?.contains(e.target) && e.target.id !== "workspace-settings-search-input" && showPopup) {
      setShowPopup(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mouseup', handleClickOutside);
    return () => document.removeEventListener('mouseup', handleClickOutside);
  })

  const handleGetUsersList = (id) => {
http.post(`data_connector/workspace/${id}/assignable_users/`,
      {})
      .then(res => {
        const selectedWorkspaceData = {...context.handleWorkspace().find(workspace => workspace.id === id)}
        const data = res.data.data.filter(user => !selectedWorkspaceData?.users.find(item => item === user.username))
        setUsers(res.data.data)
        setUsersToShow(data)
      })
      .catch(err=>{
        console.log(err.response)
      })
  }

  const handleRemoveUserFromList = (list, removedUser) => {
    const listData = [...list]
    return listData.filter(item => item.username !== removedUser.username)
  }

  useEffect(() => {
    if (props.showModal && context.handleSelectedWorkspaceInfo()?.id) {
      handleGetUsersList(context.handleSelectedWorkspaceInfo().id)
    } else if (!props.showModal) {
      setUsers([])
      setUsersToShow([])
      setAddedUsers([])
    }
  }, [props.showModal, context.handleSelectedWorkspaceInfo()])

  const handleAddUser = (user) => {
    setApiResponse("pending")
    http.post(`data_connector/workspace/${context.handleSelectedWorkspaceInfo().id}/add_user/`,
      {
        to_users: [user.username]
      })
      .then(res => {
        setApiResponse("success")
        const data = [...context.handleWorkspace()]
        const id = (data.findIndex(item => item.id === context.handleSelectedWorkspaceInfo().id))
        const users = [...data[id].users, user.username]
        data.splice(id, 1, {
          ...data[id],
          users
        })
        context.handleWorkspace(data)
        setAddedUsers([...addedUsers, user])
        setUsersToShow(handleRemoveUserFromList(usersToShow, user))
      })
      .catch(err => {
        console.log(err.response)
        setApiResponse("error")
      })
  }

  const handleRemoveUser = (user) => {
    setApiResponse("pending")
    http.post(`data_connector/workspace/${context.handleSelectedWorkspaceInfo().id}/remove_user/`,
      {
        to_user: user.username
      })
      .then(res => {
        setApiResponse("success")
        const data = [...context.handleWorkspace()]
        const id = (data.findIndex(item => item.id === context.handleSelectedWorkspaceInfo().id))
        console.log(id)
        const users = data[id].users.filter(item => item !== user.username)
        data.splice(id, 1, {
          ...data[id],
          users
        })
        context.handleWorkspace(data)
        setAddedUsers(handleRemoveUserFromList(addedUsers, user))
        setUsersToShow([...usersToShow, user])
      })
      .catch(err => {
        console.log(err.response)
        setApiResponse("error")
      })
  }

  const handleGetWorkspaceInfo = () => {
    return context.handleWorkspace().find(workspace => workspace.id === context.handleSelectedWorkspaceInfo().id)
  }

  moment.locale('en', {
    calendar : {
      lastDay : '[Yesterday,] LT',
      sameDay : '[Today,] LT',
      nextDay : '[Tomorrow,] LT',
      lastWeek : '[last] dddd [at] LT',
      nextWeek : 'dddd [at] LT',
      sameElse : 'L'
    }
  });

  const handleKeyDown = (e) => {
    if (e.keyCode === 38 && cursor > 0) {
      setCursor(cursor - 1)
    } else if (e.keyCode === 40 && cursor < usersToShow.length - 1) {
      setCursor(cursor + 1)
    } else if (e.keyCode === 13) {
      handleAddUser(usersToShow.find((_, index) => index === cursor))
      setShowPopup(false)
    }
  }

  const generalTemplate = () => {
    const workspace = handleGetWorkspaceInfo()

    return workspace ? <div className={[styles.general, "row"].join(" ")}>
      <div className={"col-sm-3"}>
        <div className={styles.title}>
          Name
        </div>
        <div className={styles.text} title={workspace?.name}>
          { workspace?.name }
        </div>
      </div>
      <div className={"col-sm-4"}>
        <div className={styles.title}>
          Created by
        </div>
        <div className={styles.text} title={workspace?.owner}>
          { workspace?.owner }
        </div>
      </div>
      <div className={"col-sm-5"}>
        <div className={styles.title}>
          Creation Date & Time
        </div>
        <div className={styles.text} title={new moment(workspace?.created).format("DD MMM YYYY, hh:mm")}>
          { new moment(workspace?.created).format("DD MMM YYYY, hh:mm") }
        </div>
      </div>
      <div className={'col-sm-12 mt-4'}>
        <div className={styles.title}>
          Description
        </div>
        <div className={styles.text} title={workspace?.description}>
          { workspace?.description || "-" }
        </div>
      </div>
      <div className={'col-sm-12 mt-4'}>
        <div className={styles.title}>
          Collaborators
        </div>
        <div className={styles.text} title={workspace?.users?.join(", ")}>
          { workspace?.users?.join(", ") }
        </div>
      </div>
      <div className={'col-sm-5 mt-4'}>
        <div className={styles.title}>
          Last Modified Date
        </div>
        <div className={styles.text} title={new moment(workspace?.modified).calendar()}>
          { new moment(workspace?.modified).calendar() }
        </div>
      </div>
      <div className={'col-sm-6 mt-4'}>
        <div className={styles.title}>
          Last Modified by
        </div>
        <div className={styles.text}>
          { workspace?.owner }
        </div>
      </div>
    </div> : <React.Fragment></React.Fragment>
  }

  const handleSearchUsers = (e) => {
    const value = e.target.value.trim()
    let searchData = []
    searchData = users.filter(user => !addedUsers.find(item => item.username === user.username) && user.username !== localStorage.getItem("username"))
    if (value.length) {
      searchData = searchData.filter(user => user.username.toLowerCase().includes(value.toLowerCase()));
    }
    setUsersToShow(searchData)
  }

  const collaboratorsTemplate = <div className={styles.collaborators}>
    <div className={styles.title}>
      Add team members to this workspace
    </div>
    <div className={'position-relative'}>
      <Input
        id={"workspace-settings-search-input"}
        placeholder={"Search Team Members..."}
        isSearch
        onFocus={() => setShowPopup(true)}
        onChange={handleSearchUsers}
        onKeydown={handleKeyDown}
      />
      {
        showPopup && usersToShow.length > 0 &&
          <div onMouseOver={() => setCursor(null)} ref={popupRef} className={styles.popup}>
            {
              usersToShow.map((user, index) => (
                <div key={`${user}_${index}`} className={ [styles.usersToShowItem, cursor === index && styles.active, "d-flex align-items-center justify-content-between"].join(" ")}>
                  <div className={"d-flex align-items-center"}>
                    <div className={[styles.profilePicture, "d-flex align-items-center justify-content-center"].join(" ")}>
                      { user.username.substr(0, 1).toUpperCase() }
                    </div>
                    <div onClick={() => handleAddUser(user)} className={[styles.username, "ml-3 cursor-pointer"].join(" ")} title={user.username}>
                      { user.username }
                    </div>
                  </div>
                  <div className={styles.role}>
                    { user.role }
                  </div>
                  <div className={styles.addButton} onClick={() => handleAddUser(user)}>
                    Add
                  </div>
                </div>
              ))
            }
          </div>
      }
    </div>
    <div className={styles.users}>
      {
        addedUsers.map((user, key) => (
          <div key={`${user}_${key}`} className={["d-flex align-items-center justify-content-between"].join(" ")}>
            <div className={"d-flex align-items-center"}>
              <div className={[styles.profilePicture, "d-flex align-items-center justify-content-center"].join(" ")}>
                { user.username.substr(0, 1).toUpperCase() }
              </div>
              <div className={[styles.username, "ml-3"].join(" ")} title={user.username}>
                { user.username }
              </div>
            </div>
            <div className={styles.role}>
              { user.role }
            </div>
            <div onClick={() => handleRemoveUser(user)} className={styles.removeButton}>
              Remove
            </div>
          </div>
        ))
      }
    </div>
  </div>

  const tabs = [
    {
      id: 1,
      title: "General",
      content: context.handleWorkspace() ? generalTemplate() : <div></div>
    },
    {
      id: 2,
      title: "Collaborators",
      content: collaboratorsTemplate
    }
  ]

  return (
    <div className={styles.WorkspaceSettings}>
      <ModalBox
        fixedSize={520}
        title={"Workspace Settings"}
        showModal={props.showModal}
        handleTriggerShowModal={props.onTriggerShowWorkspaceSettingsModal}
      >
        <div className={styles.content}>
          <div className={[styles.tabs, "d-flex justify-content-center"].join(" ")}>
            {
              tabs.map((tab, index) => (
                <div key={`${tab.title}_${index}`} className={[styles.tab, selectedTabId === tab.id && styles.active].join(" ")} onClick={() => setSelectedTabId(tab.id)}>
                  { tab.title }
                </div>
              ))
            }
          </div>
          <div className={styles.tabsContent}>
            {
              tabs.map((tab, index) => (
                selectedTabId === tab.id &&
                  <React.Fragment key={`${tab.title}_${index}`}>
                      { tab.content }
                  </React.Fragment>
              ))
            }
          </div>
        </div>
      </ModalBox>
    </div>
  )
}

export default WorkspaceSettings